import Permissions from "../../models/Permissions";

const SimplesNacional = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Simples Nacional",
  icon: "fa fa-files-o",
  group: "Simples Nacional",
  permissions,
};

export default [
  {
    path: "/SimplesNacional",
    name: "SimplesNacional",
    component: SimplesNacional,
    meta,
  },
];
